import { ReactNode } from "react";
import { styled } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

import { palette } from "theme/palette";
import { ThemeType } from "theme/types";

type StepIconProps = {
  active: boolean;
  completed: boolean;
  className?: string;
  icon: ReactNode;
};

const useStyles = makeStyles((theme: ThemeType) => {
  return {
    root: {
      backgroundColor: palette.accent,
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1,
      [theme.breakpoints.down("sm")]: {
        width: "24px",
        height: "24px",
      },
    },
  };
});

const StepIconComponentRoot = styled("div")(
  ({ ownerState }: { ownerState: { active: boolean } }) => ({
    color: palette.accent,
    display: "flex",
    height: 22,
    alignItems: "center",
    ...(ownerState.active && {
      color: "#784af4",
    }),
    "& .QontoStepIcon-completedIcon": {
      color: "#784af4",
      zIndex: 1,
      fontSize: 18,
    },
    "& .QontoStepIcon-circle": {
      width: "36px",
      height: "36px",
      borderRadius: "50%",
      backgroundColor: "currentColor",
    },
  })
);

const IconVariant = ({ active, completed, icon }: StepIconProps) => {
  const classnames = useStyles();

  if (active) {
    return (
      <div className={classnames.root}>
        <span style={{ color: palette.white, fontSize: "18px" }}>{icon}</span>
      </div>
    );
  }

  if (completed) {
    return (
      <div className={classnames.root}>
        <span style={{ color: palette.white, fontSize: "18px" }}>{icon}</span>
      </div>
    );
  }

  return (
    <div className={classnames.root} style={{ backgroundColor: palette.grey }}>
      <span style={{ color: palette.white, fontSize: "18px" }}>{icon}</span>
    </div>
  );
};

export const StepIconComponent = ({
  active,
  completed,
  className,
  icon,
}: StepIconProps) => {
  return (
    <StepIconComponentRoot ownerState={{ active }} className={className}>
      <IconVariant active={active} completed={completed} icon={icon} />
    </StepIconComponentRoot>
  );
};
